// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
import _ from "lodash";
window._ = _;
Vue.prototype._ = _;
Vue.use(Mint);
import vueTap from '@/assets/js/v-tap.ts';
Vue.use(vueTap);

try {
  const flage = localStorage.getItem('flage');
  if (flage === null || flage === undefined || flage === '') {
    localStorage.setItem('flage', 'true');
    localStorage.flage = 'true';
  }
} catch (e) {}

import Log from '@/utils/log';
window.Log = Log;

import "./styles/main.scss"
import App from './App';
import './components/common/reg';
import router from './router';
import '../static/css/common.css'; //引入全局css
import "./assets/iconfonts/iconfont.css";
import store from './store/index';

window.beferFooterIndex = 0;
window.footerIndex = 0;
window.crmAddress = '';
window.helpAddress = '';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})

// var attachFastClick = require('@/assets/js/fastclick.js');
// attachFastClick(document.body);



// WEBPACK FOOTER //
// ./src/main.js